import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';
import sleep from 'sleep-promise';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import Contractualizations from './Contractualizations';

function List() {
    const profileFilter = chooseProfileFilter();
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState('contractualizations');
    const [filterValues, setFilterValues] = useState({});

    const paths = {
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall'
    }

    const reloadList = async () => {
        await sleep(10);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    }

    const handleChange = async (element) => {
        const target = element['target'];
        let values = { ...filterValues, [target['name']]: target['value'] };

        // trocar a entidade invalida o projeto que estava selecionado
        if (target['name'] === 'pdc_entity_id') {
            delete values.pdc_project_id;
        }

        setFilterValues(values);

        await reloadList();
    }

    // filtros da tela: valem para todas as abas (hoje so Contratualizacao)
    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        update_key: `${filterValues.pdc_entity_id}-${filterValues.pdc_project_id}`,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id && !profileFilter.pdc_project_ids ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4,
            } : {},
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter,
                            // 'none' faz o backend devolver vazio enquanto nenhuma entidade foi escolhida
                            pdc_entity_id: filterValues.pdc_entity_id || profileFilter.pdc_entity_id || 'none'
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4,
            }
        ],
        values: {
            pdc_entity_id: filterValues.pdc_entity_id,
            pdc_project_id: filterValues.pdc_project_id
        }
    }), [filterValues]);

    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: activeTab === "contractualizations" })}
                        onClick={() => {
                            setActiveTab("contractualizations");
                        }}
                    >
                        Contratualização
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="contractualizations">
                    <Col sm="12">
                        <Contractualizations
                            profileFilter={profileFilter}
                            filterValues={filterValues}
                            filters={filters}
                        />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
}
export default List;
